import React from 'react'
import Icon from 'react-icon-base'

const ArticleIcon = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <path d="m5 28.8l18.4-18.5 6.3 6.3-18.4 18.4h-6.3v-6.2z m29.5-17.1l-3.1 3.1-6.2-6.2 3.1-3.1c0.7-0.7 1.5-0.7 2.2 0l4 4c0.7 0.7 0.7 1.5 0 2.2z" />
    </g>
  </Icon>
)

export default ArticleIcon
